import './style.scss';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <section className='notFound' style={{backgroundImage:'url(/img/notfoundbg.jpg)'}}>
            <div className='container'>
                <h1 className='title'>404 - Az oldal nem található  :(</h1>
                <p className='description'>Sajnáljuk! A kért oldalt nem lehet betölteni.</p>
                <Link to="/" style={{ textDecoration: 'none', color: '#007BFF' }}>
                    <button className='button'>
                       Vissza a főoldalra!
                    </button>
                </Link>
            </div>
        </section>
    );
};

export default NotFound;
